var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Veículo","titleIcon":"fas fa-bus"}},[_c('form-veiculo',{attrs:{"paramId":_vm.id},on:{"onSubmitVeiculo":_vm.afterSubmit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }